import { useCallback, useState } from 'react';
import { useNotification } from '../../provider/ToastNotificationProvider';
import { virtualNumberLoadingSlice } from '../../store/virtualNumberLoadingSlice';
import { usePostVirtualNumberMutation } from '../api/virtual-number/mutations/usePostVirtualNumber.mutation';
import { useAppDispatch } from '../store/useStore';

interface IUseVirtualNumberInquiryParams {
  productId: string;
  productCode: string;
  sellerPhoneNumber: string;
}

interface IUseVirtualNumberInquiryReturn {
  callWithVirtualNumber: () => void;
  isLoading: boolean;
  shouldShowModal: boolean;
  virtualNumber: string | null;
  closeModal: () => void;
}

export const useVirtualNumberInquiry = ({
  productId,
  productCode,
  sellerPhoneNumber,
}: IUseVirtualNumberInquiryParams): IUseVirtualNumberInquiryReturn => {
  const dispatch = useAppDispatch();
  const virtualNumberLoadingActions = virtualNumberLoadingSlice.actions;
  const { openNotification } = useNotification();
  const { mutate: postVirtualNumber, isLoading } = usePostVirtualNumberMutation();
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const [virtualNumber, setVirtualNumber] = useState<string | null>(null);

  const closeModal = useCallback(() => {
    setShouldShowModal(false);
    setVirtualNumber(null);
  }, []);

  const callWithVirtualNumber = () => {
    if (!sellerPhoneNumber) {
      openNotification({
        message: '판매자 전화번호 정보가 없습니다.',
        type: 'error',
      });
      return;
    }

    // TODO: 운영 배포 이후 주석 해제 필요 - prod 환경에서만 안심번호 발급하도록 설정
    // const isProduction = process.env.REACT_APP_CLIENT_ENVIRONMENT === 'production';

    // // 운영 환경이 아니면 실제 번호로 바로 전화
    // if (!isProduction) {
    //   // 개발 환경에서도 모달 표시
    //   setShouldShowModal(true);
    //   setVirtualNumber(sellerPhoneNumber);
    //   vibrateDefault();
    //   return;
    // }

    // 모든 환경에서 안심번호 발급 (임시)
    // 전역 로딩 시작
    dispatch(virtualNumberLoadingActions.setVirtualNumberLoading(true));

    // 안심번호 발급 API 호출 (판매자의 실제 전화번호를 전달)
    postVirtualNumber(
      {
        productId,
        productCode,
        realNumber: sellerPhoneNumber,
      },
      {
        onSuccess: (data) => {
          // 전역 로딩 종료
          dispatch(virtualNumberLoadingActions.setVirtualNumberLoading(false));

          // 가상번호 저장 및 모달 표시
          setVirtualNumber(data.virtualNumber);
          setShouldShowModal(true);

          // 진동은 CallGuideModal 컴포넌트에서 처리
        },
        onError: (error) => {
          // 전역 로딩 종료
          dispatch(virtualNumberLoadingActions.setVirtualNumberLoading(false));

          // 안심번호 발급 실패 시 알림
          openNotification({
            message: '안심번호 발급에 실패했습니다. 잠시 후 다시 시도해주세요.',
            type: 'error',
          });
          console.error('안심번호 발급 실패:', error);
        },
      },
    );
  };

  return {
    callWithVirtualNumber,
    isLoading,
    shouldShowModal,
    virtualNumber,
    closeModal,
  };
};
